import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';
import { /* position, */ rem } from 'polished';
import Icon from '../../core/Icon';
import AvatarPerson from '../../core/AvatarPerson';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

// Caja con Usuario y  listado enlaces
export const StyledBoxUser = styled.div`
  background-color: ${props => props.theme.colors.light};
  height: 100%;
  position: fixed;
  padding-left: ${rem('100px')};
  padding-top: ${rem('94px')};
  position: fixed;
  transform: translate(100%, 0);
  transition-delay: initial;
  transition-duration: 0.4s;
  transition-property: initial;
  transition-timing-function: ease-in-out;
  top: 0;
  width: ${rem('310px')};
  z-index: 15;
  ${mediaqueries.lessThan('mobile')`
    padding-left: ${rem('64px')};
    padding-top:${rem('64px')};
    width:${rem('243px')};
    display:${props => (props.menuUser ? 'block' : 'none')};
  `};

  ${mediaqueries.greaterThan('mobile')`
    padding-left: ${rem('64px')};
    padding-top: ${rem('64px')};
    width:${rem('243px')};
    height: calc(100% - 3.125rem);
    overflow: unset;
    width: ${rem('310px')};
    top: 0;
    background-color: ${props => props.theme.colors.light};
    height: 100%;
    position: fixed;
    padding-left: 5.25rem;
    padding-top: 5.875rem;
    position: fixed;
    right: 0;
    z-index: 15;
    box-shadow: ${props => props.menuUser && '10px 10px 5px 10px'};
    transform: translateX${props => (!props.menuUser ? '100%' : '0')};
    transition-delay: initial;
    transition-duration: 0.4s;
    transition-property: initial;
    transition-timing-function: ease-in-out;
  `};
  ${mediaqueries.lessThan('desktop')`
    padding-left: ${rem('64px')};
    padding-top: ${rem('64px')};
    width:${rem('243px')};
    height: calc(100% - 3.125rem);
    overflow: unset;
    width: ${rem('310px')};
    top: 0;
    background-color: ${props => props.theme.colors.light};
    height: 100%;
    position: fixed;
    padding-left: 5.25rem;
    padding-top: 5.875rem;
    position: fixed;
    right: 0;
    z-index: 15;
    box-shadow: ${props => props.menuUser && '10px 10px 5px 10px'};
    transform: translateX${props => (!props.menuUser ? '100%' : '0')};
    transition-delay: initial;
    transition-duration: 0.4s;
    transition-property: initial;
    transition-timing-function: ease-in-out;
  `};
  ${mediaqueries.greaterThan('desktop')`
    box-shadow: rgb(0 0 0 / 30%) 1px 3px 0px;
    display:${props => (props.menuUser ? 'block' : 'none')};
    height:auto;
    padding-left:0;
    padding-top:0;
    top:${rem('72px')};
    right: -1rem;
    position: absolute;
    transform: translate(0);
    width:${rem('252px')};
  `};
  &:after {
    background-color: ${props => props.theme.colors.dark};
    content: '';
    display: none;
    height: 100%;
    left: -600%;
    opacity: 0;
    position: fixed;
    top: 0;
    width: 600%;
    z-index: -1;
  }
  &:before {
    content: '';
    border-left: ${rem('10px')} solid transparent;
    border-right: ${rem('10px')} solid transparent;
    // border-top: ${rem('12px')} solid ${props => props.theme.colors.light};
    display: none;
    height: 0;
    position: absolute;
    right: ${rem('12px')};
    top: 0;
    width: 0;
    z-index: 6;
    ${mediaqueries.greaterThan('desktop')`
      display:block;
    `};
  }
  /* prop para desplegar usuario */
  ${props =>
    props.show &&
    css`
      transform: translate(0);
      &:after {
        opacity: 0.7;
        display: block;
      }
      ${mediaqueries.greaterThan('desktop')`
        display:block;
        &:after {
          display:none;
        }
      `};
    `};
`;

// Caja para foto de perfil
export const StyledPerfil = styled.figure`
  border-radius: 50%;
  box-shadow: 0 0 0 ${rem('1px')} ${props => props.theme.colors.dark},
    0 0 0 ${rem('4px')} ${props => props.theme.colors.light};
  height: ${rem('82px')};
  img {
    height: 100%;
    width: 100%;
  }
  margin-bottom: ${rem('40px')};
  margin-left: ${rem('5px')};
  margin-top: ${rem('5px')};
  overflow: hidden;
  width: ${rem('82px')};
  ${mediaqueries.lessThan('mobile')`
    height: ${rem('54px')};
    margin-bottom: ${rem('25px')};
    width: ${rem('54px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    display:none;
  `};
`;

// Icono cerrar para dispositivos
export const StyledIconClose = styled(Icon)`
  fill: ${props => props.theme.colors.primary};
  height: ${rem('19px')};
  left: ${rem('33px')};
  position: absolute;
  top: ${rem('22px')};
  width: ${rem('19px')};
  ${mediaqueries.lessThan('mobile')`
    left: ${rem('22px')};
    top: ${rem('20px')};
  `};
  ${mediaqueries.lessThan('desktop')`
    position: fixed;
    top: 20px;
    right: 30px;
  `};
  ${mediaqueries.greaterThan('desktop')`
    display:none;
  `};
`;

// Icono flecha colapse
export const StyledIconCollapase = styled(Icon)`
  display: none;
  height: ${rem('16px')};
  position: absolute;
  right: ${rem('30px')};
  top: ${rem('-5px')};
  width: ${rem('16px')};
  z-index: 6;
  ${mediaqueries.greaterThan('desktop')`
    display:block;
  `};
`;

// Caja para scroll en dispositivos
export const StyledDivScroll = styled.div`
  height: calc(100% - ${rem('50px')});
  overflow: auto;
  ${mediaqueries.lessThan('mobile')`
    height: calc(100% - ${rem('43px')});
  `};

  ${mediaqueries.greaterThan('desktop')`
    height:inherit;
  `};
`;

// Listado
export const StyledList = styled.ul`
  margin: 0;
  margin-top: ${rem('15px')};
  padding-bottom: ${rem('20px')};
  padding-left: 0;
  position: relative;
  ${mediaqueries.greaterThan('desktop')`
    margin-top:0;
    padding-bottom:0;
  `};
  &:after {
    background-color: ${props => props.theme.colors.grayDark};
    bottom: 0;
    content: '';
    height: ${rem('4px')};
    position: absolute;
    width: ${rem('20px')};
    ${mediaqueries.greaterThan('desktop')`
      display:none;
    `};
  }
  &:last-child:after {
    display: none;
  }
`;

// Elementos del listado
export const StyledElement = styled.li`
  list-style: none;
  padding-left: 0;
  &:before {
    content: none;
  }
`;

// Enlaces no en desktop
export const StyledElmentMenu = StyledElement.extend`
  ${mediaqueries.greaterThan('desktop')`
    display:none;
  `};
`;

const LinkStyles = css`
  align-items: center;
  cursor: pointer;
  color: ${props => props.theme.colors.dark};
  display: flex;
  height: ${rem('50px')};
  font-family: ${props => props.theme.fonts.medium};
  font-size: 1rem;
  width: 100%;
  ${mediaqueries.lessThan('mobile')`
    height: ${rem('43px')};
  `};
  ${mediaqueries.lessThan('desktop')`
    &:hover {
    color: ${props => props.theme.colors.primary};
  }
  `};
  ${mediaqueries.greaterThan('desktop')`
    padding-left: ${rem('70px')};
    color: ${props => props.theme.colors.dark};
    &:hover {
      background-color:${props => props.theme.colors.grayDarkest};
      border-right:${rem('4px')} solid ${props => props.theme.colors.primary};
      color: ${props => props.theme.colors.light};
    }
  `};
`;

// Enlaces
export const StyledLink = styled(NavLink).attrs({
  to: props => (props.to ? props.to : '/')
})`
  ${LinkStyles};
`;

export const StyledOuterLink = styled.a`
  ${LinkStyles};
`;

// Icono Logout
export const StyledIconLogout = styled(Icon)`
  fill: ${props => props.theme.colors.dark};
  height: ${rem('18px')};
  margin-right: ${rem('10px')};
  width: ${rem('18px')};
  ${mediaqueries.lessThan('mobile')`
    left: ${rem('22px')};
    top: ${rem('20px')};
  `};
  ${mediaqueries.lessThan('desktop')`
    left: ${rem('22px')};
    top: ${rem('20px')};
    fill: ${props => props.theme.colors.light};
  `};
  ${mediaqueries.greaterThan('desktop')`
    fill: ${props => props.theme.colors.dark};
  `};
`;

// Logout
export const StyledLogout = StyledLink.extend`
  background-color: ${props => props.theme.colors.grayDarkest};
  padding-left: ${rem('120px')};
  margin-left: ${rem('-84px')};
  width: auto;
  color: ${props => props.theme.colors.light};
  fill: ${props => props.theme.colors.light};
  &:hover {
    color: ${props => props.theme.colors.light};
    ${StyledIconLogout} {
      fill: ${props => props.theme.colors.light};
    }
  }
  ${mediaqueries.lessThan('mobile')`
    padding-left: ${rem('64px')};
    // margin-left: ${rem('-64px')};
    width: auto;
  `};
  ${mediaqueries.greaterThan('desktop')`
    background-color:inherit;
    margin-left: 0;
  `};
`;

export const StyledAvatarPerson = styled(AvatarPerson)`
  font-size: ${rem('21px')};
  border: none;
  width: 100%;
  height: 100%;
`;
